import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  Divider,
  message,
  Tabs,
  Space
} from 'antd';
import {
  UserOutlined,
  LockOutlined,
  MailOutlined,
  GithubOutlined,
  WechatOutlined,
  QqOutlined
} from '@ant-design/icons';
import './index.css';

const { Title, Text, Link } = Typography;
const { TabPane } = Tabs;

const Auth = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('login');

  const onLoginFinish = async (values) => {
    setLoading(true);
    try {
      // 模拟登录API调用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('登录信息:', values);
      message.success('登录成功！');
      
      // 存储用户信息到localStorage
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('user', JSON.stringify({
        username: values.username,
        email: 'user@example.com'
      }));
      
      // 跳转到首页
      navigate('/');
      window.location.reload();
    } catch (error) {
      message.error('登录失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const onRegisterFinish = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.error('两次输入的密码不一致');
      return;
    }

    setLoading(true);
    try {
      // 模拟注册API调用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('注册信息:', values);
      message.success('注册成功！请登录');
      
      // 切换到登录标签页
      setActiveTab('login');
      form.resetFields();
    } catch (error) {
      message.error('注册失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleSocialLogin = (platform) => {
    message.info(`${platform}登录功能开发中`);
  };

  return (
    <div className="auth-page">
      <Card className="auth-card">
        <div className="auth-header">
          <Title level={2} className="auth-title">我的博客</Title>
          <Text type="secondary">欢迎来到我的技术博客</Text>
        </div>

        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          centered
          className="auth-tabs"
        >
          {/* 登录标签页 */}
          <TabPane tab="登录" key="login">
            <Form
              form={form}
              layout="vertical"
              onFinish={onLoginFinish}
              className="auth-form"
            >
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: '请输入用户名' },
                  { min: 3, message: '用户名至少3个字符' }
                ]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="用户名"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6个字符' }
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="密码"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <div className="form-options">
                  <Checkbox>记住我</Checkbox>
                  <Link className="forgot-link">忘记密码？</Link>
                </div>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  size="large"
                  className="auth-btn"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </TabPane>

          {/* 注册标签页 */}
          <TabPane tab="注册" key="register">
            <Form
              layout="vertical"
              onFinish={onRegisterFinish}
              className="auth-form"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: '请输入邮箱' },
                  { type: 'email', message: '请输入有效的邮箱地址' }
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="邮箱"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="username"
                rules={[
                  { required: true, message: '请输入用户名' },
                  { min: 3, message: '用户名至少3个字符' },
                  { max: 20, message: '用户名不能超过20个字符' }
                ]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="用户名"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6个字符' }
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="密码"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                rules={[
                  { required: true, message: '请确认密码' }
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="确认密码"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <Checkbox>我已阅读并同意服务条款</Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  size="large"
                  className="auth-btn"
                >
                  注册
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>

        <Divider>或使用以下方式登录</Divider>

        {/* 第三方登录 */}
        <div className="social-login">
          <Space size="large">
            <Button
              type="default"
              icon={<GithubOutlined />}
              onClick={() => handleSocialLogin('GitHub')}
              className="social-btn"
            >
              GitHub
            </Button>
            <Button
              type="default"
              icon={<WechatOutlined />}
              onClick={() => handleSocialLogin('微信')}
              className="social-btn"
            >
              微信
            </Button>
            <Button
              type="default"
              icon={<QqOutlined />}
              onClick={() => handleSocialLogin('QQ')}
              className="social-btn"
            >
              QQ
            </Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Auth;